<template>
  <section
    id="gallery"
    v-infinite-scroll="fetchImages"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="0"
  >
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container ">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>Designs</h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p>A collection of designs I've worked on</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-bottom-big over-hide">
      <div class="container px-3 px-xl-5">
        <div id="portfolio-filter" class="portfolio-filter ml-3 mb-4 mb-xl-5">
          <ul id="filter">
            <li
              v-for="(category, index) in categories"
              :key="category"
              @click="filterImages(category, index)"
            >
              <span class="target" :class="{ current: activeIndex == index }">{{
                category
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="container px-3 px-xl-5">
        <GalleryBox :images="images" :category="tag" />
      </div>
    </div>

    <h6 class="text-center" style="opacity: 0.2">
      {{ loadedAllImages ? "That's All Folks" : "Loading More Images.." }}
    </h6>
  </section>
</template>

<script>
import { EventBus } from "../main";
import { ParallaxEffect } from "@/components/utils";
import { mapGetters, mapActions, mapMutations } from "vuex";
import infiniteScroll from "vue-infinite-scroll";

import GalleryBox from "@/components/GalleryBox";
export default {
  data() {
    return {
      categories: ["all", "designs", "logos", "illustrations", "ui"],
      activeIndex: 0,
      tag: "all",
      loadedAllImages: false
    };
  },
  watch: {
    images(value) {
      if (value.length === this.totalDocuments) {
        this.loadedAllImages = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      images: "images/images",
      busy: "images/busy",
      totalDocuments: "images/totalDocuments"
    })
  },
  components: {
    GalleryBox
  },
  methods: {
    filterImages(category, index, boo) {
      this.activeIndex = index;
      this.tag = category;

      if (!boo) this.$router.replace({ name: "Designs", query: { category } });
    },
    ...mapActions({ fetchImages: "images/fetchImages" }),
    ...mapMutations({ setBusy: "images/setBusy" }),
    autoFilter() {
      let category = this.$route.query.category;
      let index = this.categories.findIndex(c => c == category);
      if (index >= 0) this.filterImages(category, index, true);
    }
  },
  directives: { infiniteScroll },
  mounted() {
    EventBus.$emit("allLinks", document.querySelectorAll("a, .target, button"));
    ParallaxEffect(this.$el);
    this.autoFilter();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "Designs") {
      return;
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
#portfolio-filter {
  position: relative;
  text-align: center;
  width: 100%;
}

#filter {
  position: relative;
  display: block;
  padding: 0;
  margin: 0;

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

#filter li {
  display: inline-block;
  margin-right: 15px;
  padding: 0;
  float: left;

  @media (max-width: 575px) {
    a {
      letter-spacing: 0;
      font-size: 14px;
    }
  }

  span {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    outline: none;
    color: rgba(200, 200, 200, 0.5);
    font-weight: 700;
    font-style: italic;
    letter-spacing: 1px;
    font-size: 15px;
    line-height: 22px;
    text-decoration: none;
    transition: all 300ms linear;

    &:hover {
      color: #fff;

      &::before {
        bottom: -4px;
        opacity: 1;
        visibility: visible;
      }
    }

    &:before {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: -9px;
      height: 2px;
      content: "";
      z-index: -1;
      background-color: $primary;
      opacity: 0;
      visibility: hidden;
      transition: all 200ms linear;
    }

    &.current {
      color: #fff;

      &:before {
        bottom: -4px;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}

.target {
  cursor: pointer;
}
</style>
